import React, { useState, useEffect } from "react";
import Login from "./Login";
import TextEditor from "./TextEditor";
import { baiduAnalytics } from "./utils/baiduAnalytics";

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (baiduAnalytics.isLoaded()) {
      const path = window.location.pathname + window.location.search;
      baiduAnalytics.trackPageView(path);
    } else {
      setTimeout(() => {
        if (baiduAnalytics.isLoaded()) {
          const path = window.location.pathname + window.location.search;
          baiduAnalytics.trackPageView(path);
        }
      }, 1000);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlUser = params.get("user");
    const urlPsw = params.get("psw");
    
    if (urlUser && urlPsw) {
      setUsername(urlUser);
      setPassword(urlPsw);
      setIsLoggedIn(true);
      localStorage.setItem("textStorage_username", urlUser);
      localStorage.setItem("textStorage_password", urlPsw);
    } else {
      const savedUsername = localStorage.getItem("textStorage_username");
      const savedPassword = localStorage.getItem("textStorage_password");
      if (savedUsername && savedPassword) {
        setUsername(savedUsername);
        setPassword(savedPassword);
        setIsLoggedIn(true);
        const newParams = new URLSearchParams();
        newParams.set("user", savedUsername);
        newParams.set("psw", savedPassword);
        window.history.replaceState({}, "", `?${newParams.toString()}`);
        // 自动登录时也设置用户ID用于UV统计
        baiduAnalytics.trackUV(savedUsername);
      }
    }
  }, []);

  const handleLogin = (user: string, pass: string) => {
    setUsername(user);
    setPassword(pass);
    setIsLoggedIn(true);
    localStorage.setItem("textStorage_username", user);
    localStorage.setItem("textStorage_password", pass);
    const params = new URLSearchParams();
    params.set("user", user);
    params.set("psw", pass);
    window.history.pushState({}, "", `?${params.toString()}`);
    
    // 追踪登录事件和PV
    baiduAnalytics.trackEvent('用户操作', '登录', user);
    baiduAnalytics.trackPageView(window.location.pathname + window.location.search);
    // 设置用户ID用于UV统计
    baiduAnalytics.trackUV(user);
  };

  const handleLogout = () => {
    baiduAnalytics.trackEvent('用户操作', '登出', username);
    setIsLoggedIn(false);
    setUsername("");
    setPassword("");
    localStorage.removeItem("textStorage_username");
    localStorage.removeItem("textStorage_password");
    window.history.pushState({}, "", window.location.pathname);
    baiduAnalytics.trackPageView(window.location.pathname);
  };

  return (
    <div style={{ minHeight: "100vh", padding: "16px", position: "relative" }}>
      <div style={{ maxWidth: "800px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        {!isLoggedIn ? (
          <Login onLogin={handleLogin} />
        ) : (
          <TextEditor username={username} password={password} onLogout={handleLogout} />
        )}
      </div>
    </div>
  );
};

export default App;
